import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { addQuestionGroup } from 'services/questionGroups';
import PropTypes from 'prop-types';

const AddQuestionGroupModal = ({
  survey_id,
  show,
  handleClose,
  refreshGroups
}) => {
  const [newGroup, setNewGroup] = useState({
    title: '',
    description: '',
    order_index: '',
    show_description: false,
    show_title: true
  });

  const handleSubmit = e => {
    e.preventDefault();

    // Prepara los datos para enviar, convirtiendo descripción vacía a null
    const dataToSend = {
      ...newGroup,
      description: newGroup.description.trim() || null,
      survey_id
    };

    addQuestionGroup(dataToSend)
      .then(response => {
        if (response.result) {
          toast.success('Grupo de preguntas agregado exitosamente.', {
            theme: 'colored'
          });
          refreshGroups(); // Recargar los datos en la tabla
          handleClose(); // Cerrar el modal
          setNewGroup({
            title: '',
            description: '',
            order_index: '',
            show_description: false,
            show_title: true
          }); // Limpiar el formulario
        } else {
          toast.error('Error al agregar el grupo de preguntas.', {
            theme: 'colored'
          });
        }
      })
      .catch(error => {
        console.error('Error al agregar el grupo de preguntas:', error);
        toast.error('Error al agregar el grupo de preguntas.', {
          theme: 'colored'
        });
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Agregar Grupo de Preguntas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row className="g-2">
            <Col md={12}>
              <Form.Group>
                <Form.Label>Título</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={newGroup.title}
                  onChange={e =>
                    setNewGroup({ ...newGroup, title: e.target.value })
                  }
                  placeholder="Título del grupo"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  id="show_title_group"
                  name="show_title"
                  checked={newGroup.show_title}
                  onChange={e =>
                    setNewGroup({ ...newGroup, show_title: e.target.checked })
                  }
                  label="Mostrar este título en la encuesta"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={newGroup.description}
                  onChange={e =>
                    setNewGroup({ ...newGroup, description: e.target.value })
                  }
                  placeholder="Descripción del grupo (opcional)"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  id="show_description_group"
                  name="show_description"
                  checked={newGroup.show_description}
                  onChange={e =>
                    setNewGroup({
                      ...newGroup,
                      show_description: e.target.checked
                    })
                  }
                  label="Mostrar esta descripción en la encuesta"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Label>Orden</Form.Label>
                <Form.Control
                  type="number"
                  name="order_index"
                  value={newGroup.order_index}
                  onChange={e =>
                    setNewGroup({ ...newGroup, order_index: e.target.value })
                  }
                  placeholder="Orden"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="success" type="submit" className="ms-2">
              Agregar
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

AddQuestionGroupModal.propTypes = {
  survey_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  refreshGroups: PropTypes.func
};

export default AddQuestionGroupModal;
